import { useQuery } from '@tanstack/react-query';

import { getOrderMessageThreads } from 'app/services/messages';

export const getOrderMessageThreadKey = (orderId) => ['clinicOrder', orderId, 'messageThread'];

export default function useOrderMessageThread(orderId) {
  const {
    data: { messageThreads } = {},
    isLoading,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: getOrderMessageThreadKey(orderId),
    queryFn: () => getOrderMessageThreads({ orderId }),
    enabled: Boolean(orderId),
    cacheTime: 60,
    refetchOnWindowFocus: false,
  });

  return {
    messageThread: messageThreads?.[0],
    isLoading,
    isFetched,
    refetch,
  };
}
